import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FileText, BookOpen, Book, Mail, LogOut, Lock, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/admin/login");
  };

  const adminUser = localStorage.getItem("adminUser");

  const sections = [
    { title: "Manage Blogs", icon: <FileText className="h-12 w-12" />, path: "/admin/blogs", color: "text-primary" },
    { title: "Manage Book Summaries", icon: <BookOpen className="h-12 w-12" />, path: "/admin/book-summaries", color: "text-secondary" },
    { title: "Manage Books", icon: <Book className="h-12 w-12" />, path: "/admin/books", color: "text-primary" },
    { title: "Manage Testimonials", icon: <MessageSquare className="h-12 w-12" />, path: "/admin/testimonials", color: "text-secondary" },
    { title: "View Contact Submissions", icon: <Mail className="h-12 w-12" />, path: "/admin/contacts", color: "text-primary" }
  ];

  return (
    <div className="min-h-screen bg-background">
      <nav className="glass-effect border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div>
            <h1 className="font-heading text-2xl font-bold text-text-primary">Admin Dashboard</h1>
            <p className="text-text-secondary text-sm">Welcome, {adminUser}</p>
          </div>
          <div className="flex gap-3">
            <Link to="/admin/change-password">
              <Button variant="outline" className="border-primary/30" data-testid="change-password-link">
                <Lock className="mr-2 h-4 w-4" /> Change Password
              </Button>
            </Link>
            <Button onClick={handleLogout} variant="ghost" data-testid="admin-logout-button">
              <LogOut className="mr-2 h-4 w-4" /> Logout
            </Button>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {sections.map((section, index) => (
            <Link key={index} to={section.path} data-testid={`admin-section-${index}`}>
              <div className="glass-effect p-8 rounded-2xl hover:-translate-y-1 transition-all group">
                <div className={`${section.color} mb-4`}>{section.icon}</div>
                <h3 className="font-heading text-xl font-semibold text-text-primary group-hover:text-primary transition-colors">
                  {section.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}